import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Highlight } from '../Highlight';
import { bonos, bonosTotal } from '../../data/landing';
export function Bonos() {
  return <section id="bonos" className="scroll-mt-4 bg-ink px-5 py-16 md:py-24" data-id="element-60" data-mp="1hig417vib375">
      <div className="mx-auto max-w-5xl" data-id="element-61" data-mp="1ckek6kq9azum">
        <SectionHeading eyebrow="Siempre incluidos" title={<>
              6 Bonos <Highlight data-id="element-63" data-mp="ovvco7f16r3l">Estratégicos</Highlight>
            </>} data-id="element-62" data-mp="1clh8ckw72o6u" />

        <ul className="mt-12 space-y-3" data-id="element-64" data-mp="jwadpwzv2iqv">
          {bonos.map(b => <li key={b.number} className="grid grid-cols-[auto_1fr] gap-4 rounded-2xl border border-line bg-surface p-5 sm:grid-cols-[auto_1fr_auto] sm:items-center md:p-6" data-id="element-65" data-mp="jxts1i1yijq0">
              <span className="flex h-14 w-14 flex-col items-center justify-center rounded-xl border border-line bg-ink text-heading" data-id="element-66" data-mp="tteoz1s64tsw">
                <GiftIcon className="h-5 w-5 text-success" aria-hidden="true" data-id="element-67" data-mp="62j4yqtyf2w7" />
                <span className="text-xs font-black" data-id="element-68" data-mp="14zm1dmba1xx">{b.number}</span>
              </span>
              <div data-id="element-69" data-mp="2z9w6act14016">
                <p className="text-xs font-black uppercase tracking-wider text-body" data-id="element-70" data-mp="2z8bc4oammj3u">
                  Bono {Number(b.number)}
                </p>
                <p className="text-lg font-extrabold leading-tight text-heading" data-id="element-71" data-mp="38zyw644usxva">{b.title}</p>
                <p className="mt-1 text-sm text-body md:text-base" data-id="element-72" data-mp="3d2c0qp7v6pqh">{b.description}</p>
              </div>
              <div className="col-span-2 flex items-center justify-between gap-4 border-t border-line pt-3 sm:col-span-1 sm:flex-col sm:items-end sm:border-t-0 sm:pt-0" data-id="element-73" data-mp="2gcbh14mcqzg1">
                <span className="whitespace-nowrap text-sm text-body" data-id="element-74" data-mp="2pc7zupm29436">
                  Valorado: <span className="line-through decoration-danger" data-id="element-75" data-mp="2pecdhz9rhhgn">{b.value}</span>
                </span>
                <span className="rounded-full bg-success/15 px-3 py-1 text-sm font-black uppercase text-success" data-id="element-76" data-mp="2u8yed8i7vrmh">
                  Gratis
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 rounded-2xl border border-accent/40 bg-surface px-6 py-5 text-center sm:flex-row sm:text-left" data-id="element-77" data-mp="25o8apm45s86b">
          <p className="text-lg text-body" data-id="element-78" data-mp="21oprqvvwe764">
            Valor total bonos:{' '}
            <span className="font-black text-heading line-through decoration-danger decoration-2" data-id="element-79" data-mp="2flw8kkx29vsp">{bonosTotal}</span>
          </p>
          <p className="text-xl font-black uppercase text-accent" data-id="element-80" data-mp="2alianvp6c28e">→ Gratis con tu MegaPack</p>
        </div>
      </div>
    </section>;
}